<template>
  <div class="c-idea g-container">
    <!-- 导航 -->
    <Breadcrumb style="margin-bottom: 12px">
      <BreadcrumbItem :to="{ name: 'plan', query: { id: idea.campaignFeedId, t: 'edit' } }">
        <Icon type="ios-home-outline"></Icon> 设置推广计划
      </BreadcrumbItem>
      <BreadcrumbItem :to="{ name: 'unit', query: { ad: idea.ad_id, t: 'edit' } }">
        <Icon type="logo-buffer"></Icon> 设置推广单元
      </BreadcrumbItem>
      <BreadcrumbItem> <Icon type="ios-cafe"></Icon> 设置创意 </BreadcrumbItem>
    </Breadcrumb>

    <moduler v-for="item in subModules" :media="media" :key="item.id" :name="item.href" :title="item.name">
      <!-- 创意素材 -->
      <template v-if="item.href === 'idea_media'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">创意</span>
          </Col>
          <Col span="12">
            <div
              v-for="(item, id) in creatives"
              :key="id"
              @click="setCurrent(id)"
              :class="{ 'm-current': item.check, 'm-creative-btn': true }"
            >
              创意{{ id + 1 }}
              <span class="m-remove" @click.stop="delCurrent(id)">x</span>
            </div>
            <Button v-if="addState" type="text" icon="md-add" class="m-creat-btn" @click="addCreative()">添加创意</Button>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">创意样式</span>
          </Col>
          <Col span="21">
            <RadioGroup v-model="materialstyle" type="button" @on-change="changeMaterialStyle">
              <Radio v-for="temp in templates" :key="temp.id" :label="temp.id">{{ temp.name }}</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="18">
            <creative :data="currentCreative" :verify="verify" :source="creativeDetails"></creative>
          </Col>
        </Row>
      </template>

      <!-- 创意提交相关 -->
      <template v-if="item.href === 'idea_tags'">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">品牌名</span>
          </Col>
          <Col span="12">
            <input-len
              v-model="idea.brand"
              charset="init"
              placeholder="请输入品牌名"
              :max="8"
              :disabled="editState"
              width="420"
            ></input-len>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">头像图片</span>
          </Col>
          <Col span="12">
            <creat-icon
              v-model="idea.userPortrait"
              name="icon"
              :width="120"
              :height="120"
              :size="1024"
              :format="imageFormat"
              :disabled="editState"
              @on-upload="uploadFileHandle"
            >
            </creat-icon>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="appType">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">推广URL</span>
          </Col>
          <Col span="12">
            <Input v-model="idea.naUrl" disabled placeholder="以http或https开头，长度不能大于1024个字符" style="width: 420px"></Input>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">点击监测链接</span>
          </Col>
          <Col span="12">
            <Input
              v-model="idea.monitorUrl"
              :disabled="editState"
              placeholder="以http或https开头，长度不能大于1024个字符"
              style="width: 420px"
            ></Input>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">创意名称</span>
          </Col>
          <Col span="12">
            <input-len v-model="currentFeedName" placeholder="最大60个字符，1个中文等于2个字符" :max="60" disabled width="420"></input-len>
          </Col>
        </Row>
      </template>
    </moduler>

    <!-- 批量结果 -->
    <resulter
      v-model="model"
      :show="loading"
      title="建立创意结果反馈"
      head="创意创建结果"
      :columns="columns"
      :data="data"
      :next="false"
      @on-retry="retry"
    ></resulter>

    <div class="c-idea-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="cannelError"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button type="default" @click="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="saving" @click.stop="save">
            <span v-if="!saving">保存</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submitToNext">
            <span v-if="!loading">完成</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
import { isArray, isEmpty, timeout, getByteLen } from '@/common/js/utils'
// 引用模版
import advTemplates from '@/data/baidu/adv_templates'
// 引用组件
import Creative from './components/creative/creative.vue'
import resulter from './components/convert/resulter.vue'
import CreatIcon from './components/creative/creat-icon.vue'
// model
import { getCampaign, getAdgroup, getCreative, creatCreative, editCreative } from '@/api/baidu.model'
export default {
  name: 'idea',
  mixins: [mixin],
  components: { Creative, resulter, CreatIcon },
  computed: {
    editState() {
      return this.$router.currentRoute.query.t === 'edit'
    },
    addState() {
      return this.creatives.length < 10
    },
    templates() {
      const advs = this.advTemplates.filter((ret) => {
        // 可用模版
        let ftypes
        const isSubject = ret.subject === this.subject
        // 类型流量可包含
        if (typeof this.leagueOpenFlag === 'number') {
          ftypes = ret.site.some(
            (met) =>
              this.ftypes.includes(met.ftypes) &&
              met.product.some((p) => this.product.includes(p)) &&
              isArray(met.leagueOpenFlag) &&
              met.leagueOpenFlag.some((p) => this.leagueOpenFlag === p)
          )
        } else {
          ftypes = ret.site.some((met) => this.ftypes.includes(met.ftypes) && met.product.some((p) => this.product.includes(p)))
        }
        return isSubject && ftypes
      })
      const current = this.advTemplates.filter((ret) => ret.id === this.materialstyle)
      return this.currentType === 2 ? current : advs
    },
    currentCreative() {
      return this.creatives[this.currentIndex] ? this.creatives[this.currentIndex].creative : []
    }
  },
  methods: {
    getData() {
      const params = {
        accountId: this.idea.account,
        ids: [this.idea.ad_id]
      }
      getCreative(params).then((data) => {
        if (isArray(data) && data.length) {
          // 架构创意
          timeout(100).then(() => {
            this.creatives = data.map((ret) => {
              const { creativeFeedId, creativeFeedName, materialstyle, material } = ret
              return {
                creativeId: creativeFeedId,
                creativeFeedName,
                materialstyle,
                creative: this.decompile(material, materialstyle),
                creatives_detail: [
                  {
                    videoid: material.videoid,
                    finalUrl: material.video_url
                  }
                ],
                brand: material.brand,
                monitorUrl: material.monitorUrl,
                userPortrait: material.userPortrait,
                operateType: 2
              }
            })
            // 选择第一个创意
            this.setCurrent(0)
          })
        }
        this.$Spin.hide()
      })
    },
    // 反解析创意
    decompile(elements, style) {
      const creative = this.getCurrentIndexTemplate(style)
      return creative.map((ret) => {
        if (isArray(ret.children)) {
          ret.children = ret.children.map((met, id) => {
            // 适用对象\数组
            if (isArray(elements[ret.name])) met[met.name] = elements[ret.name][id].image
            else met[met.name] = elements[ret.name][met.name]
            return met
          })
        } else {
          if (ret.name === 'video') ret[ret.name] = parseInt(elements[ret.name]) // 返回视频ID转整型
          else ret[ret.name] = elements[ret.name]
        }
        return ret
      })
    },
    createTemplate(element) {
      const { material } = element
      const arrayElement = material.filter((ret) => ret.element_type === 'ELEMENT_TYPE_STRUCT')
      const imageElement = material.filter((ret) => ret.element_type === 'ELEMENT_TYPE_IMAGE' && !ret.parent_name)
      const videoElement = material.filter((ret) => ret.element_type === 'ELEMENT_TYPE_VIDEO' && !ret.parent_name)
      const titleElement = material.filter((ret) => ret.name === 'title' && !ret.parent_name)
      const textElement = material.filter((ret) => ret.element_type === 'ELEMENT_TYPE_TEXT' && ret.name !== 'title' && !ret.parent_name)
      const urlElement = material.filter((ret) => ret.element_type === 'ELEMENT_TYPE_URL' && !ret.parent_name)

      if (arrayElement.length) {
        arrayElement.forEach((ret) => {
          const fieldType = ret.field_type
          const parentName = ret.name
          // 数组成员
          if (fieldType === 'FIELD_TYPE_STRUCT_ARRAY') {
            const { min_number } = ret.array_property
            const child = material.filter((met) => met.parent_name === parentName).pop()
            const childName = child.name
            ret.children = Array.from(Array(min_number)).map((v, k) => {
              return Object.assign({}, child, {
                name: `${childName}${k + 1}`
              })
            })
          }
        })
      }
      if (urlElement.length) {
        urlElement.forEach((ret) => {
          ret.enum_property = { default: this.idea.url }
        })
      }
      return [...arrayElement, ...imageElement, ...videoElement, ...titleElement, ...textElement, ...urlElement]
    },
    // 添加素材
    addCreative() {
      const creative = this.getCurrentIndexTemplate(this.materialstyle)
      const item = {
        materialstyle: this.materialstyle,
        creative,
        creatives_detail: [],
        creativeFeedName: this.idea.creativeFeedName,
        brand: this.idea.brand,
        monitorUrl: this.idea.monitorUrl,
        userPortrait: this.idea.userPortrait,
        operateType: 1
      }
      this.creatives.push(item)
      this.setCurrent(this.creatives.length - 1)
    },
    // 选中创意
    setCurrent(ret) {
      // 验证时重验
      if (this.verify) {
        this.verify = false
        timeout(0).then(() => {
          this.verify = true
        })
      }
      this.creatives.forEach((met) => {
        this.$set(met, 'check', false)
      })
      this.currentIndex = ret
      const item = this.creatives[this.currentIndex]
      this.$set(item, 'check', true)
      this.materialstyle = item.materialstyle
      this.currentFeedName = item.creativeFeedName
      this.currentType = item.operateType
      this.creativeDetails = item.creatives_detail
      if (this.editState) {
        this.idea.brand = item.brand
        this.idea.monitorUrl = item.monitorUrl
        this.idea.userPortrait = item.userPortrait
      }
    },
    // 删除创意
    delCurrent(id) {
      const len = this.creatives.length
      if (len < 2) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '不能删除最后一个创意'
        })
        return
      }
      if (this.creatives[id].operateType && this.creatives[id].operateType === 2) {
        // 编辑时删除
        this.$set(this.creatives[id], 'operateType', 3)
        this.delCreatives.push(this.creatives[id])
      }
      if (id > 0) this.setCurrent(id - 1)
      this.creatives.splice(id, 1)
    },
    changeMaterialStyle(val) {
      // 验证时重验
      if (this.verify) {
        this.verify = false
        timeout(0).then(() => {
          this.verify = true
        })
      }
      const creative = this.getCurrentIndexTemplate(val)
      this.$set(this.creatives[this.currentIndex], 'creative', creative) // 创建模版
      this.$set(this.creatives[this.currentIndex], 'materialstyle', val)
    },
    getCurrentIndexTemplate(style) {
      if (!style) return []
      let creativeJson = []
      const index = this.templates.findIndex((ret) => ret.id === style)
      if (index > -1) creativeJson = this.createTemplate(this.templates[index]) // 在合法模版
      else {
        // 非法模版
        const tempData = this.advTemplates.filter((ret) => ret.id === style).pop()
        if (tempData) creativeJson = this.createTemplate(tempData)
      }
      return JSON.parse(JSON.stringify(creativeJson))
    },
    // 选择素材回调
    uploadFileHandle({ name, size, data }) {
      // 素材大小判断
      const iconSize = data.size / 1000
      if (size < iconSize) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '上传的文件超过限制大小'
        })
        return
      }
      if (name === 'icon') this.$set(this.idea, 'userPortrait', data.url)
    },
    preloadData() {
      const account = this.idea.account
      // 查推广计划详细
      const param = {
        id: this.idea.campaignFeedId,
        ad_account_id: account
      }
      const param1 = {
        ad_id: this.idea.ad_id,
        ad_account_id: account
      }
      this.$Spin.show()
      Promise.all([getCampaign(param), getAdgroup(param1)])
        .then((data) => {
          if (!data) {
            this.$Message.error({
              duration: 5,
              content: '推广单元信息错误，无法创建创意！'
            })
            this.$Spin.hide()
            return
          }
          const [campaignData, adGroupData] = data
          if (isArray(campaignData) && campaignData.length) {
            const { subject } = campaignData.pop()
            this.subject = subject
          }
          if (adGroupData && adGroupData.out_plan_info) {
            let lpUrl
            const { out_plan_info, plan_info } = adGroupData
            if (isArray(out_plan_info) && out_plan_info.length) {
              const { ftypes, producttypes, leagueOpenFlag, ocpc } = out_plan_info[0]
              this.ftypes = isArray(ftypes) && !ftypes.length ? [1, 2, 4] : ftypes
              this.product = isArray(producttypes) && !producttypes.length ? [1, 2] : producttypes
              this.leagueOpenFlag = typeof leagueOpenFlag === 'number' && leagueOpenFlag
              ocpc && (lpUrl = ocpc.lpUrl)
            }
            // 如果有内部计划
            if (plan_info) {
              this.idea.creativeFeedName = plan_info.plan_name
              this.idea.monitorUrl = plan_info.track_chain_addr
              this.appType = plan_info.landing_type === 'APP' && plan_info.ch_platform_id === 2
              if (this.appType) this.idea.naUrl = plan_info.game_pack_addr
              else this.idea.url = lpUrl || plan_info.page_addr
            }
            if (!this.editState && this.templates.length) {
              this.materialstyle = this.templates[0].id
              this.addCreative()
            }
          }
          if (this.editState) this.getData()
          else this.$Spin.hide()
        })
        .catch((e) => {
          this.$Spin.hide() // 加载完成
        })
    },
    mergeCreative(creatives) {
      return creatives.map((ret) => {
        const operateType = ret.operateType || 1
        const creativeFeedId = ret.creativeId
        const creativeFeedName = ret.creativeFeedName
        const materialstyle = ret.materialstyle
        const monitorUrl = ret.monitorUrl || this.idea.monitorUrl
        const userPortrait = ret.userPortrait || this.idea.userPortrait
        const brand = ret.brand || this.idea.brand
        const short = [112, 111, 109, 108].includes(materialstyle)
        const material = this.build(ret.creative, ret.creatives_detail, monitorUrl, userPortrait, brand, short)
        ret = { materialstyle, creativeFeedName, material }
        if (this.editState) ret = Object.assign({}, ret, { operateType, creativeFeedId })
        return ret
      })
    },
    build(item, detail, clickUrl, userPortrait, brand, short) {
      if (!isArray(item)) throw new Error('合并素材错误，素材原型非数组')

      // 非样式模版
      const adcreative = {}
      item.forEach((ret) => {
        if (ret.element_type === 'ELEMENT_TYPE_STRUCT') {
          if (ret.field_type === 'FIELD_TYPE_STRUCT_ARRAY' && isArray(detail)) {
            let picture_width
            let picture_height
            adcreative[ret.name] = ret.children.map((met) => {
              picture_width = met.restriction.image_restriction.width
              picture_height = met.restriction.image_restriction.height
              return { image: met[met.name] }
            })
            adcreative.picture_width = picture_width
            adcreative.picture_height = picture_height
          }
        } else {
          if (ret.name === 'poster' && isArray(detail)) {
            adcreative.poster = ret[ret.name]
            // 骚操作
            if (short) adcreative.pictures = [{ image: adcreative.poster }]
          } else adcreative[ret.name] = ret[ret.name]
        }
      })
      adcreative.monitorUrl = clickUrl
      adcreative.userPortrait = userPortrait
      adcreative.brand = brand
      return adcreative
    },
    customValid(creatives) {
      let flag
      let index = 0
      for (const ret of creatives) {
        index++
        const { creative } = ret
        const verify = creative.map((met) => {
          let stat
          if (['poster', 'videoid'].includes(met.name)) {
            if (met.required) stat = !isEmpty(met[met.name])
            else stat = true
          } else if (['title', 'subtitle', 'url'].includes(met.name)) {
            const min = met.restriction.text_restriction.min_length
            const max = met.restriction.text_restriction.max_length
            const pattern = met.restriction.text_restriction.text_pattern
            const regx = new RegExp(pattern)
            if (met.required) {
              stat =
                !isEmpty(met[met.name]) && getByteLen(met[met.name]) <= max && getByteLen(met[met.name]) >= min && regx.test(met[met.name])
            } else stat = true
          } else if (met.name === 'pictures') {
            stat = met.children.every((t) => {
              return t.required ? !isEmpty(t[t.name]) : true
            })
          }
          return stat
        })
        console.log(verify)
        if (!verify.every((f) => f)) {
          flag = true
          break
        }
      }
      return flag ? index - 1 : -1
    },
    valid() {
      const rules = [
        {
          name: 'currentFeedName',
          required: true,
          min: 1,
          max: 60,
          desc: '创意名称'
        },
        {
          name: 'creatives',
          require: true,
          min: 1,
          max: 20,
          desc: '创意样式',
          msg: '最少提交1个视频，最多提交20个视频'
        },
        {
          name: 'idea/naUrl',
          require: true,
          relyon: 'appType',
          relyvalue: true,
          min: 1,
          max: 1024,
          desc: '推广URL'
        },
        {
          name: 'idea/monitorUrl',
          require: true,
          min: 1,
          max: 1024,
          pattern: '^((https|http)?://)[^s]+',
          desc: '点击监测链接'
        },
        {
          name: 'idea/userPortrait',
          require: true,
          min: 1,
          max: 1024,
          pattern: '^((https|http)?://)[^s]+',
          desc: '头像图片'
        },
        {
          name: 'idea/brand',
          require: true,
          min: 1,
          max: 8,
          charset: 'bc',
          desc: '品牌名'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    save() {
      this.errRes = [...this.valid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const index = this.customValid(this.creatives)
      if (index > -1) {
        this.verify = true
        this.setCurrent(index)
        return
      }
      const mergeCreatives = [...this.mergeCreative(this.creatives), ...this.mergeCreative(this.delCreatives)] // 素材
      const params = {
        accountId: this.idea.account,
        adId: this.idea.ad_id,
        creatives: mergeCreatives
      }

      this.saving = true
      editCreative(params).then((data) => {
        this.saving = false
        if (data) {
          this.$Message.success('保存成功')
          timeout(2000).then(() => {
            this.cannel()
          })
        }
      })
    },
    submitToNext() {
      this.errRes = [...this.valid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const index = this.customValid(this.creatives)
      if (index > -1) {
        this.verify = true
        this.setCurrent(index)
        return
      }
      const mergeCreatives = [...this.mergeCreative(this.creatives), ...this.mergeCreative(this.delCreatives)] // 素材
      const params = {
        accountId: this.idea.account,
        adId: this.idea.ad_id,
        req_id: this.idea.req_id,
        creatives: mergeCreatives
      }

      this.loading = true
      creatCreative(params).then((data) => {
        this.loading = false
        if (isArray(data) && data.length) {
          this.model = true
          this.data = data
        }
      })
    }
  },
  data() {
    return {
      loading: null,
      saving: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值

      subject: 1, // 推广对象
      ftypes: [], // 媒体流量
      product: [], // 版位
      appType: null,
      creativeIndex: 0, // 创意索引
      creatives: [], // 创意素材
      delCreatives: [], // 删除素材
      currentIndex: 0,
      currentFeedName: '', // 当前显示创意标题
      currentType: 0, // 当前显示创意类型
      creativeDetails: [], // 素材详情
      advTemplates: advTemplates, // 创意模版数据
      materialstyle: 0, // 模板ID

      idea: {
        account: this.$store.state.Baidu.account,
        campaignFeedId: parseInt(this.$router.currentRoute.params.id), // 广告组ID
        req_id: this.$router.currentRoute.query.req, // 批量ID
        ad_id: parseInt(this.$router.currentRoute.params.ad), // 计划ID、
        ch_plan_id: parseInt(this.$router.currentRoute.query.plan), // 内部计划
        creativeId: parseInt(this.$router.currentRoute.query.id), // 创意ID
        creativeFeedName: '',

        url: '',
        naUrl: '',
        brand: '',
        userPortrait: '', // 用户头像
        monitorUrl: '' // 点击监测链接
      },

      imageFormat: ['IMAGE_TYPE_JPG', 'IMAGE_TYPE_PNG'],
      verify: false, // 验证状态

      model: null, // 批量结果对话框显示状态
      columns: [
        {
          key: 'media_name',
          title: '媒体'
        },
        {
          key: 'campaign_name',
          title: '推广计划'
        },
        {
          key: 'plan_name',
          title: '推广单元'
        },
        {
          key: 'creative_name',
          title: '创意名称'
        },
        {
          key: 'msg',
          title: '创意建立结果'
        }
      ], // 结果表格
      data: [] // 批量结果
    }
  },
  created() {
    if (this.$router.currentRoute.query.t !== 'edit') this.beforeHandler()
    this.$store.commit('UC/clearModulerLinks')
    this.preloadData()
  }
}
</script>
<style lang='scss' scoped>
/* 表单 */
.row-item {
  align-items: flex-start;
}

.item-field {
  height: 32px;
  line-height: 32px;
}

.row-item-label {
  text-align: right;
  padding: 8px;
}

.m-creative-btn {
  border-radius: 4px;
  border: solid 1px #efefef;
  position: relative;
  display: inline-block;
  line-height: 32px;
  padding: 0 12px;
  margin-right: 12px;
}

.m-current {
  color: #2b85e4;
  border-color: #2b85e4;
}

.m-creat-btn {
  color: #2b85e4;
}

.m-remove {
  position: absolute;
  cursor: pointer;
  color: #fff;
  width: 11px;
  height: 11px;
  line-height: 11px;
  font-size: 60%;
  border-radius: 9px;
  background-color: #ff635c;
  text-align: center;
  display: block;
  z-index: 11;
  top: -6px;
  right: -3px;
  transition: display 0.2s ease-in-out;
}

/* 提交按钮 */
.c-idea-submit {
  padding: 15px;
  min-width: 1130px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 #eff1fa;

  .c-btns-submit {
    text-align: right;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
